import React, { ReactNode, Fragment } from 'react';
import { Header } from '../features/Header';
import { Container } from '../shared/Container';

interface BaseLayoutProps {
    children?: ReactNode;
}

export function BaseLayout({ children }: BaseLayoutProps) {
    function getDisclaimerUrl() {
        const path = window.location.pathname;
        let url = 'Jaap.nl';

        if (path.includes('fundamliapp') || path.includes('fundamlimobile')) {
            url = 'Funda.nl';
        }
        if (path.includes('goudadesktop') || path.includes('goudamobile')) {
            url = 'Westergouwe.nl';
        }

        if (path.includes('huislijnmlidesktop') || path.includes('huislijnmlimobile')) {
            url = 'Huislijn.nl';
        }

        if (path.includes('huispediamlidesktop') || path.includes('huispediamlimobile')) {
            url = 'Huispedia.nl';
        }

        if (path.includes('jaapmlidesktop') || path.includes('jaapmlimobile')) {
            url = 'Jaap.nl';
        }

				if (path.includes('huizenzoekermlidesktop') || path.includes('huizenzoekermlimobile')) {
					url = 'Huizenzoeker.nl';
				}

        return (
            <a href={url} target="_blank" rel="noopener noreferrer">
                {url}
            </a>
        );
    }

    return (
        <Fragment>
            <Header />

            <main id="content" role="main">
                <Container>
                    {children}
                    <div className="u-margin-top--md u-text--copy">
                        Deze Maandlastenindicator respectievelijk dit Hypotheekformulier wordt
                        verzorgd door De Hypothekers Associatie B.V.. De Hypothekers Associatie B.V.
                        (DHA) stelt u met deze dienst in de gelegenheid om berekeningen uit te
                        voeren. Op deze dienst is onze{' '}
                        <a
                            href="https://hypotheker.nl/disclaimer/"
                            target="_blank"
                            rel="noopener noreferrer">
                            disclaimer
                        </a>
                        ,{' '}
                        <a
                            href="https://hypotheker.nl/copyright/"
                            target="_blank"
                            rel="noopener noreferrer">
                            copyright
                        </a>{' '}
                        en{' '}
                        <a
                            href="https://hypotheker.nl/privacy-statement/"
                            target="_blank"
                            rel="noopener noreferrer">
                            privacy statement
                        </a>{' '}
                        van toepassing. Alle eventueel door u ingevoerde gegevens zullen worden
                        ingevoerd bij DHA en niet bij {getDisclaimerUrl()}. Deze berekeningen worden
                        uitgevoerd op basis van algemene uitgangspunten en door u ingevoerde
                        gegevens en kunnen afwijken van de voor u geldende omstandigheden. De
                        uitkomsten van de berekeningen zijn uitsluitend ter indicatie en daaraan
                        kunnen dan ook geen rechten ontleend worden. DHA aanvaardt geen enkele
                        aansprakelijkheid voor de werking van de berekeningen, dan wel voor de
                        uitkomst daarvan. DHA is als vergunninghouder ingeschreven bij de Autoriteit
                        Financiële Markten (AFM) onder vergunningnummer 12010105 en ingeschreven bij
                        de Kamer van Koophandel onder dossiernummer 24187850.
                    </div>
                </Container>
            </main>
        </Fragment>
    );
}
